<template>
    <div>

        <my-header h1="Lesson Plan" :h4="param.Course + ' ' + param.Session"></my-header>

        <div id="copy">
            <div v-for="c in lessonPlan" style="page-break-after: always">
                <h3 style="border-top: 1px solid black; border-bottom: 1px solid black; background-color: lightgray; margin-top: 5px; margin-bottom: 10px">{{c.Chapter}} <small style="float: right; margin-top: 1.5px;">{{c.Term}}</small></h3>
                <div class="col-lg-6 col-md-12 col-sm-12" v-for="(t, i) in c.Topics">
                    <table border="1" width="100%" style="font-size: 12px; border-collapse: collapse; margin-bottom: 10px">
                        <tr>
                            <th colspan="2" style="font-size: 14px; background-color: lightgray; ">
                                Topic {{i + 1}}: {{t.Topic}} <small style="float: right; margin-top: 2px;"> {{t.Progress.toFixed(0)}}% Completed</small>
                            </th>
                        </tr>
                        <tr>
                            <th style="width: 20%; text-align: left">Duration Required</th>
                            <td style="width: 80%">{{t.CompletionTime}} minutes</td>
                        </tr>
                        <tr>
                            <th>Description</th>
                            <td>{{t.Description}} <span v-if="!t.Description">-</span></td>
                        </tr>
                        <tr>
                            <th>Objectives</th>
                            <td>
                                <ul>
                                    <li v-for="o in t.Objectives">{{o}}</li>
                                </ul>
                                <span v-if="t.Objectives.length == 0">-</span>
                            </td>
                        </tr>
                        <tr>
                            <th>Outcomes</th>
                            <td>
                                <ul>
                                    <li v-for="o in t.Outcomes">{{o}}</li>
                                </ul>
                                <span v-if="t.Outcomes.length == 0">-</span>
                            </td>
                        </tr>
                        <tr v-for="o in t.QuestionCategories">
                            <th>{{o.Category}}</th>
                            <td>
                                <ul>
                                    <li v-for="q in o.Questions">
                                        {{q.Question}} <br />
                                        <img v-if="q.Attachment" :src="q.Attachment" :height="q.Height" />
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th>Activities</th>
                            <td>
                                <ul>
                                    <li v-for="o in t.Activities"><b>{{o.Category}}:</b> {{o.Activity}}</li>
                                </ul>
                                <span v-if="t.Activities.length == 0">-</span>
                            </td>
                        </tr>
                    </table>

                </div>
            </div>

        </div>
    </div>
</template>

<script>const axios = require('axios').default;
    var XLSX = require("xlsx");

    export default ({
        data() {
            return {
                param: { Session: '', Course: '', Class: '', Type: '', Date: '', Title: '' },
                lessonPlan: []
            }
        },
        created: function () {
            this.pageLoad();
        },
        updated: function () {
        },
        methods: {
            pageLoad() {
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams) {
                    var teacherID = Number(urlParams.get('teacherID'));
                    //var uri = window.location.toString();
                    //if (uri.indexOf("?") > 0) {
                    //    var clean_uri = uri.substring(0, uri.indexOf("?"));
                    //    window.history.replaceState({}, document.title, clean_uri);
                    //}

                    if (!teacherID)
                        window.location.href = "../Home";

                    var vm = this;
                    axios.post('/api/PortalApi/pageLoadLessonPlanPrint?teacherID=' + teacherID)
                        .then(function (res) {
                            vm.param = res.data.param;
                            vm.lessonPlan = res.data.lessonPlan;
                        })
                }
            },

            getPropertyWithh(l) {
                return ((100 / l) + "%");
            },

            getExportObject() {

                return {
                    sheetName: this.param.Session + "_" + this.param.Course,
                    tables: [
                        { tbl: 'tbl2', name: 'Assessment Print' },
                    ]
                };

            },

        }
    })</script>
<style scoped>
       
    td, th {
        padding-left: 1px;
        text-align: left;
    }
    ul, ol {
        padding-left: 14px;
        margin-bottom: 0px;
    }

     
</style>



// WEBPACK FOOTER //
// src/components/school/lessonPlan/lessonPlanPrint.vue